import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { SessionInterface } from '../data';
import { SessionProvider } from '../providers/session.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetSessionUseCase implements UseCase<Observable<Transaction<SessionInterface>>> {
    constructor(private sessionProvider: SessionProvider) {}

    bind(): Observable<Transaction<SessionInterface>> {
        return this.sessionProvider.current().pipe(
            map((transaction) =>
                transaction.map(
                    (session) => Transaction.success(cloneDeep(session)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
